export const REGISTERING_INTERESTS_EQUIPMENT_OFFERS = "EQUIPMENT_OFFERS";
export const REGISTERING_INTERESTS_SHOW_EQUIPMENTS = "SHOW_EQUIPMENTS";
export const REGISTERING_INTERESTS_GENERAL = "GENERAL";
